import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "border rounded shadow p-4 flex items-center justify-between" }
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-pencil" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]


import { readableDate } from "@/assets/utils/date";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingOptions',
  props: {
  showEdit: {
    type: Boolean,
    required: false,
    default: false,
  },
  day: {
    type: Date,
    required: true,
  },
  booking: {
    type: Object,
    required: true,
  },
},
  emits: ["changeOptions"],
  setup(__props, { emit }) {



const changeOptions = () => emit("changeOptions");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.booking.attendeesCount) + " " + _toDisplayString(_ctx.$t("person", { count: __props.booking.attendeesCount })) + " " + _toDisplayString(_ctx.$t("on").toLowerCase()) + " " + _toDisplayString(_unref(readableDate)({ date: __props.day, lang: _ctx.$i18n.locale })) + " " + _toDisplayString(_ctx.$t("at").toLowerCase()) + " " + _toDisplayString(__props.booking.at), 1),
    (__props.showEdit)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "border border-black px-2 py-1 relative hover:shadow-lg cursor-pointer bg-gray-100",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (changeOptions()))
        }, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}
}

})